// What the user can edit on each editor page, as a plain value. Only fields the user changes belong
// here: anything the app computes on its own (coverage, loading flags) would make an untouched page
// look edited.

import { pickState } from './unsavedChanges'

const DEFINITION_KEYS = [
  'selectedWeightType',
  'sequenceWeightsDecay',
  'selectedModelId',
  'sortedModelDrivers',
  'sortedModelWeights',
  'scoringDefinitionSettings',
  'scoringProfileDefinitionSelectValue',
]

// Efficiency Test: name, description, scoring definition, and the comparison criteria (which live in
// the local state of the ComparisonCriteria component, not in Vuex).
export function efficiencyTestSnapshot(vm) {
  const { state, getters } = vm.$store
  return {
    name: getters['efficiencyTestsCommon/getScoringProfileName'],
    description: getters['efficiencyTestsCommon/getScoringProfileDescription'],
    definition: pickState(state.efficiencyTestsDefinition, [...DEFINITION_KEYS, 'passThresholdPercent']),
    criteria: vm.$refs.comparisonCriteria ? vm.$refs.comparisonCriteria.getCriteriaPayload() : null,
  }
}

// Scoring profile: name, description, scoring definition and the filters that define its perimeter.
export function scoringProfileSnapshot(vm) {
  const { state, getters } = vm.$store
  return {
    name: getters['scoringProfilesCommon/getScoringProfileName'],
    description: getters['scoringProfilesCommon/getScoringProfileDescription'],
    definition: pickState(state.scoringProfilesDefinition, DEFINITION_KEYS),
    filters: state.scoringProfilesFilters.filters,
  }
}

// Scoring model: name, the families it uses and their weights.
export function scoringModelSnapshot(vm) {
  return pickState(vm.$store.state.scoringProfilesModelsEditing, [
    'scoringProfileModelName',
    'scoringProfileSelectedFamilies',
    'scoringProfileModelFamiliesWeights',
  ])
}
